import React from "react";
import { Form, Input, Modal, Typography } from "antd";
const { Text } = Typography;

interface AboutUsModalProps {
  visible: boolean;
  onCancel: () => void;
}

const AboutUsModal: React.FC<AboutUsModalProps> = ({ visible, onCancel }) => {
  return (
    <Modal
      open={visible}
      className='register-text-style'
      footer={null}
      width={800}
      onCancel={onCancel}
      centered={true}
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div className="col-span-1 sm:col-span-2 mt-5"></div>
        <div className="col-span-1">
          <Text strong>Administered by</Text>
          <Input defaultValue="Sonoran National Insurance Group" readOnly />
        </div>
        <div className="col-span-1">
          <Text strong>Phone</Text>
          <Input defaultValue="(800) 219-9090" readOnly />
        </div>
        
        <div className="col-span-1">
          <Text strong>Fax</Text>
          <Input defaultValue="(800) 219-9619" readOnly />
        </div>
        <div className="col-span-1">
          <Text strong>Email</Text>
          <Input defaultValue="chirofutures@sonorannational.com" readOnly />
        </div>
        <div className="col-span-1 sm:col-span-2 mb-8">
          <Text strong>Address</Text>
          <Input defaultValue="7502 E Pinnacle Peak Rd, B210, Scottsdale, AZ 85255" readOnly />
        </div>
      </div>
    </Modal>
  );
};

export default AboutUsModal;